import React, { Component } from "react";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-kit-react/views/docPage.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import Typography from "@material-ui/core/Typography";
import Button from "components/CustomButtons/Button.jsx";
import DocListItem from "components/DocList/DocListItem";
import GlobalValue from "GlobalValue";
import axios from "axios";
import EmpList from "views/DocPage/Modal/EmpList.jsx";

import SaveAlt from "@material-ui/icons/SaveAlt";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import imgOn from "assets/image/check_on.png";
import imgOff from "assets/image/check_off_g.png";
import Dropzone from "react-dropzone";
import {
  insertEdocument,
  btoa,
  _callApiMessage,
  _parceDate
} from "GlobalFunction";

// core components
function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const Today = new Date();
const TodayYear = Today.getFullYear();
const TodayMonth = Today.getMonth() + 1;
const TodayDay = Today.getDate();
const NowHour = Today.getHours();
const NowMin = Today.getMinutes();
const NowSec = Today.getSeconds();
const NowMSec = Today.getMilliseconds();
class E_Doc00 extends Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      openEmpList: false,
      EJSignGubun: 0,
      EJText: "",
      fileList: [],
      showEmpList: true,
      EJSTCode: "",
      EJOpenDateTime: `${TodayYear}-${TodayMonth}-${TodayDay} ${NowHour}:${NowSec}`,
      isSign: false
    };
  }
  handleChange = e => {
    let nextState = {};
    nextState[e.target.name] = e.target.value;

    this.setState(nextState);
  };
  handleClose = () => {
    this.props.handleEdocClose();
  };

  addEmp = emp => {
    this.setState({
      showEmpList: true,
      checkedEmp: emp,
      EJSTCode: emp.STCode
    });
  };

  _checkedItem = (value, text) => {
    if (value === undefined || value === "" || value === null) {
      alert(`${text} 을 확인하여 주세요`);
      return false;
    }
    return true;
  };
  componentDidMount = async () => {};
  shouldComponentUpda() {
    console.log("shouldCome");
  }
  handleFileChange = e => {
    // console.log(e.target.value);
    // console.log(e.target.files);
    // console.log(e.target.files[0].webkitRelativePath);
    this.setState({ fileList: e.target.files, fileUrl: e.target.value });
  };

  handleEmpList = () => {
    this.setState({ showEmpList: false });
  };
  downloadFile3 = item => {
    var docUrl = "/lineWeb/infraFileUpload/Files/WorkKyeyak/";
    var filePath = `guide.PDF`;
    // const proxyurl = "https://cors-anywhere.herokuapp.com/";
    // var url = proxyurl + docUrl + filePath + ext;
    var url = docUrl + filePath;
    console.log(url);
    // var fileDownload = require("react-file-download");
    // fileDownload(url, "전자근로계약서.PDF");
    window.open(`http://14.63.172.72/pdf?file=${url}`);
  };
  downloadFile2 = item => {
    var docUrl = "/lineWeb/infraFileUpload/Files/WorkKyeyak/";
    var filePath = `${item.EDDateTime.split(".")[0]
      .replace(" ", "")
      .replace("-", "")
      .replace(":", "")
      .replace("-", "")
      .replace(":", "")}${
      item.EDMilliSecond < 100 ? "0" + item.EDMilliSecond : item.EDMilliSecond
    }${GlobalValue.USER_INFO.SCCode}${GlobalValue.USER_INFO.SUSTCode}.PDF`;
    // const proxyurl = "https://cors-anywhere.herokuapp.com/";
    // var url = proxyurl + docUrl + filePath + ext;
    var url = docUrl + filePath;
    console.log(url);
    // var fileDownload = require("react-file-download");
    // fileDownload(url, "전자근로계약서.PDF");
    window.open(`http://14.63.172.72/pdf?file=${url}`);
  };
  downloadFile = item => {
    // console.log("click", item);
    var docUrl = "http://14.63.172.72:8080/DP4/EDocument/";
    // var docUrl = "http://linepayroll.iptime.org:8080/DP4/EDocument/";
    var filePath = `${GlobalValue.USER_INFO.SCDBName}/${item.EDDateTime.substr(
      0,
      10
    )}${item.EDDateTime.substr(11, 8)}_${item.EDMilliSecond}_${
      item.EFAddSTCode
    }${item.EFSeq + 1}`;
    var ext = this.extention(item.EFPath);
    ext = "." + ext[0];
    // const proxyurl = "https://cors-anywhere.herokuapp.com/";
    // var url = proxyurl + docUrl + filePath + ext;
    var url = docUrl + filePath + ext;
    window.open(url);
    // console.log("click", url);

    // var fileDownload = require("react-file-download");
    // fileDownload('http://14.63.172.72/lineWeb/infraFileUpload/Files/WorkKyeyak/201904021045573890v000000050v00000194.PDF', item.EFPath);
    // axios({
    //   url: url,
    //   method: "GET",
    //   responseType: "blob" // important
    // }).then(response => {
    //   console.log("fileDown", response);
    //   const url = window.URL.createObjectURL(new Blob([response.data]));
    //   const link = document.createElement("a");
    //   link.href = url;
    //   link.setAttribute("download", item.EFPath);
    //   document.body.appendChild(link);
    //   link.click();
    // });
  };

  extention(filename) {
    return /[.]/.exec(filename) ? /[^.]+$/.exec(filename) : undefined;
  }
  handleEdocEmpListClose = () => {
    this.setState({ openEmpList: false });
  };
  handleSubmit = async () => {
    if (this.props.gubun === 1) {
      this.handleClose();
      return;
    }
    if (this.props.firstList.firstEDoc[0].EDEG1Code !== 301) {
      this.handleClose();
      return;
    }
    if (this.state.EJSignGubun === 0) {
      alert("결재구분을 선택하세요");
      return;
    }
    const formData = new FormData();
    const filelist = this.state.fileList;
    if (this.state.fileList.length > 0) {
      for (var i = 0; i < filelist.length; i++) {
        var filenameBase64 = btoa(
          encodeURIComponent(filelist[i].name).replace(
            /%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
              return String.fromCharCode("0x" + p1);
            }
          )
        );
        formData.append("upload", filelist[i], filenameBase64);
      }
    }

    var dbinfo = {
      SCDBName: GlobalValue.USER_INFO.SCDBName,
      SCHostIp: GlobalValue.USER_INFO.SCHostIp
    };
    var tempInsertData = insertEdocument;
    tempInsertData.EDDateTime = this.props.item.EDDateTime;
    tempInsertData.EDMilliSecond = this.props.item.EDMilliSecond;
    tempInsertData.EDEJSeq = this.props.item.EDEJSeq + 1;
    tempInsertData.EJSignGubun = this.state.EJSignGubun;
    tempInsertData.EJBefJoinSTCode = GlobalValue.USER_INFO.SUSTCode; //직전결제자는 나
    tempInsertData.EDSTCode = this.props.item.EDSTCode; // 최초기안자
    tempInsertData.EJOpenDateTime = this.state.EJOpenDateTime; // 오픈 날짜
    tempInsertData.EJText = this.state.EJText; // 의견
    tempInsertData.EJSignGubun = this.state.EJSignGubun;

    tempInsertData.EJAftJoinSTCode = GlobalValue.USER_INFO.SUSTCode; // 최종일땐 내가 마지막
    tempInsertData.EJSTCode = GlobalValue.USER_INFO.SUSTCode;
    // tempInsertData.EJBefJoinSTCode = this.props.EDoc[
    //   this.props.EDoc.length - 1
    // ].EJBefJoinSTCode; //직전결제자는 나
    tempInsertData.EDLastJoinYN = "Y";

    formData.append("EDocObj", JSON.stringify(tempInsertData));
    formData.append("DBInfo", JSON.stringify(dbinfo));
    // console.log("formData", tempInsertData);
    axios
      .post(GlobalValue.BASE_URL + "e-doc/new", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data;charset=UTF-8"
        }
      })
      .then(response => {
        // console.log("response", response);
        if (response.status === 200) {
          return response.data;
        } else {
          alert("systemError.. 관리자에게 문의하세요..");
        }
      })
      .then(responseBody => {
        if (responseBody.code === "00") {
          if (responseBody.type === "O") {
            // Navigation.pop("DOC_TAB_STACK");
            // PUSH 전송
            var EJSignGubunTxt = GlobalValue.EJSignGubun_2.filter(
              item => item.value === this.state.EJSignGubun
            )[0].name;
            var pushBody = `등록하신 '${
              this.props.EDoc[0].EDTitle
            }'이(가) ${EJSignGubunTxt} 되었습니다.`;
            var fcmData = {
              title: "업무 요청",
              body: pushBody,
              data: {
                DATA_KEY: "02",
                DATA_GUBUN: "REF"
              }
            };
            //참조자들에게 푸시
            if (this.props.ERef.length > 0) {
              var body = `userList=${JSON.stringify(
                this.props.ERef
              )}&fcmData=${JSON.stringify(fcmData)}`;
              _callApiMessage("fcm/send/multi", body).then(responsBody => {
                // console.log("fcm/send/multi", responsBody);
              });
            }

            fcmData = {
              title: "업무 요청",
              body: this.props.EDoc[0].EDTitle,
              data: {
                DATA_KEY: "02",
                DATA_GUBUN: "OLD"
              }
            };

            // 업무요청은 최초기안자에게만 보내주도록
            var body = `SUSCCode=${GlobalValue.USER_INFO.SCCode}&SUSTCode=${
              this.state.EDSTCode
            }&fcmData=${JSON.stringify(fcmData)}`;
            _callApiMessage("fcm/send", body).then(responsBody => {
              // console.log("fcm/send", responsBody);
            });

            alert("전자 발송 하였습니다.");
            this.handleClose();
          } else {
            if (responseBody.code === "20") {
              alert(
                "에러코드 20(파일업로드)" +
                  "시스템에러.. 관리자에게 문의하세요.."
              );
            }
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  };
  handleEDSign = g => {
    // console.log(g);
    if (g === "Y") {
      this.setState({
        EJSignGubun: 0,
        isSign: false
      });
    } else {
      this.setState({
        EJSignGubun: 10,
        isSign: true
      });
    }
  };

  onPreviewDrop = files => {
    this.setState({
      fileList: this.state.fileList.concat(files)
    });
  };
  onPreviewPop = async index => {
    let sliceFile = this.state.fileList;
    sliceFile.splice(index, 1);
    await this.setState({ fileList: sliceFile });
  };
  render() {
    const { classes, EDoc, EFile, firstList, ERef, ...rest } = this.props;
    const firstEDoc = firstList.firstEDoc;
    const FIRSTFILEDATA = firstList.firstEFile;
    const btnClose = firstEDoc
      ? firstEDoc[0].EDEG1Code === 301
        ? "동의"
        : "확인"
      : "";
    const ejsigngubun = this.props.item ? this.props.item.EJSIGNGUBUN : "";
    // console.log(this.props.item);
    return (
      <div>
        <Dialog
          maxWidth="lg"
          open={this.props.openDialog}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          {this.state.showEmpList ? (
            <div>
              <DialogTitle id="alert-dialog-slide-title">{"내용"}</DialogTitle>
              {firstEDoc ? (
                <div>
                  <DialogContent>
                    <DocListItem title="제목" memo={firstEDoc[0].EDTitle} />{" "}
                    <DocListItem
                      title="보낸 사람"
                      memo={firstEDoc[0].EDSTNAME}
                    />
                    <DocListItem
                      title="구분"
                      memo={
                        GlobalValue.EG1Code_2.filter(item => {
                          return item.value === firstEDoc[0].EDEG1Code;
                        })[0].name
                      }
                    />
                    <DocListItem
                      title="작성일"
                      memo={firstEDoc[0].EDDateTime.split(".")[0]}
                    />
                    <DocListItem
                      title="문서 번호"
                      memo={firstEDoc[0].EDNumber}
                    />
                    <DocListItem title="내용" memo={firstEDoc[0].EDText} />
                    {firstEDoc[0].EDEG1Code === 301 &&
                    firstEDoc[0].EDEG2Code === 1 ? (
                      <DocListItem title={`첨부 파일 `}>
                        <SaveAlt className={classes.docItemFileimg} />
                        <label
                          className={classes.docItemFileLabel}
                          onClick={() => this.downloadFile2(firstEDoc[0])}
                        >
                          {`전자 근로 계약서`}
                        </label>
                      </DocListItem>
                    ) : null}
                    {FIRSTFILEDATA
                      ? FIRSTFILEDATA.map((item, index) => {
                          return (
                            <DocListItem
                              title={`첨부 파일 ${index + 1}`}
                              key={index}
                            >
                              <SaveAlt className={classes.docItemFileimg} />
                              <label
                                className={classes.docItemFileLabel}
                                onClick={() => this.downloadFile(item)}
                              >
                                {item.EFPath.length > 40
                                  ? `${item.EFPath.substr(0, 40)} ...`
                                  : item.EFPath}
                              </label>
                            </DocListItem>
                          );
                        })
                      : null}
                    <DocListItem title="비고" memo={firstEDoc[0].EDBigo} />
                    <DocListItem
                      title="받는사람"
                      memo={`${ERef[0].STNameKor} 외 ${ERef.length - 1} 명`}
                    />
                    {firstEDoc[0].EDEG1Code === 301 &&
                    firstEDoc[0].EDEG2Code === 1 ? (
                      <div>
                        <DocListItem title="확인" height="100px">
                          <div>
                            <label>
                              본 (전자)문서의 근로계약서 첨부파일의 내용을 확인
                              후 동의 처리로 제출한
                            </label>
                            <br />
                            <label>
                              근로계약서는 근로기준법상 서면 교부와 동일한
                              효과가 있습니다.
                            </label>
                            <br />
                            <br />
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between"
                              }}
                            >
                              <label>
                                상기 내용을 확인하고 동의 처리 합니다.
                              </label>
                              {this.props.gubun === 1 || ejsigngubun === 10 ? (
                                <img
                                  style={{
                                    height: "25px",
                                    width: "25px"
                                  }}
                                  src={imgOn}
                                />
                              ) : this.state.isSign ? (
                                <img
                                  style={{
                                    height: "25px",
                                    width: "25px"
                                  }}
                                  onClick={() => this.handleEDSign("Y")}
                                  src={imgOn}
                                />
                              ) : (
                                <img
                                  style={{
                                    backgroundColor: "#ddd",
                                    height: "25px",
                                    width: "25px"
                                  }}
                                  onClick={() => this.handleEDSign("N")}
                                  src={imgOff}
                                />
                              )}
                            </div>
                          </div>
                        </DocListItem>
                        <DocListItem title={`참조 문서 `}>
                          <SaveAlt className={classes.docItemFileimg} />
                          <label
                            className={classes.docItemFileLabel}
                            onClick={() => this.downloadFile3()}
                          >
                            {`전자 근로 가이드`}
                          </label>
                        </DocListItem>
                      </div>
                    ) : null}
                  </DialogContent>
                </div>
              ) : null}
              {this.props.gubun === 1 ? (
                <DialogActions>
                  <Button onClick={this.handleClose} color="cancel">
                    닫기
                  </Button>
                </DialogActions>
              ) : (
                <DialogActions>
                  <Button onClick={this.handleClose} color="cancel">
                    취소
                  </Button>
                  {this.state.EJSignGubun === 10 && (
                    <Button onClick={this.handleSubmit} color="submit">
                      동의
                    </Button>
                  )}
                </DialogActions>
              )}
            </div>
          ) : (
            <EmpList
              openDialog={this.state.openEmpList}
              handleEdocEmpListClose={this.handleEdocEmpListClose}
              addEmp={this.addEmp}
            />
          )}
        </Dialog>
      </div>
    );
  }
}

E_Doc00.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(E_Doc00);
